<template>
    <div class="buyInfoMode">
        <div class="buyInfoMode_bg"></div>
        <div class="buyInfoMode_content">
            <div class="buyInfoMode_content-tit">当前章节为付费章节</div>
            <div class="buyInfoMode_content-money">
                <img  @dragstart.prevent  src="../assets/icon_jinbi.png" alt="">
                <span>{{singlePrice}}</span>
            </div>
            <div class="buyInfoMode_content-btn cursorPointer" @click="$emit('handleBtn',{val:buyInfoType == 1 ? 1 : 2},targetId)">{{buyInfoType == 1 ? '立即观看' : '余额不足，立即充值'}}</div>
            <div class="buyInfoMode_content-autoPay cursorPointer" @click="$emit('changeCheckAutoSub')">
                <img  @dragstart.prevent  v-if="!checkAutoSub" src="../assets/checkbox_normal.png" alt="">
                <img  @dragstart.prevent  v-else src="../assets/icon_login_checkbox.png" alt="">
                <span>自动购买下一话</span>
            </div>
            <div class="buyInfoMode_content-info">
                当前K币余额：
                <img  @dragstart.prevent  src="../assets/icon_jinbi.png" alt="">
                {{userMoney}}
                <span class="chongzhiBtn cursorPointer" @click="$emit('handleBtn',{val:2})">充值</span>
            </div>
            <div class="buyInfoMode-close" @click="$emit('closeBuyInfoMode')">
                <img  @dragstart.prevent  src="../assets/icon_guanbi_black.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
	import router from '../router/index'
    export default {
        name: 'buyInfoMode',
        props:['singlePrice','buyInfoType','userMoney','checkAutoSub','targetId'],
    }
</script>
<style  scoped lang="scss">
.buyInfoMode{
	width: 100%;
	height: 100%;
	/*background: red;*/
	position:fixed;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 999;

    .buyInfoMode_bg{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
    }
    .buyInfoMode_content{
		width: 400px;
		height: 370px;
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        border-radius: 10px;
        display: flex;
        // justify-content: center;
        flex-direction: column;
        align-items: center;
		overflow: hidden;
		&-tit{
			font-size: 20px;
			
			color: #333333;
			line-height: 28px;
			margin-top: 19px;
		}
		&-money{
			display: flex;
			align-items: center;
			margin-top: 48px;
			img{
				width: 32px;
				height: 32px;
				margin-right: 9px;
			}
			span{
				font-size: 34px;
				
				color: #333333;
				line-height: 48px;
			}
		}
		&-btn{
			padding: 12px 25px;
			margin-top: 70px;
			background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
			border-radius: 26px;
			font-size: 20px;
			
			color: #FFFFFF;
			line-height: 28px;
		}
		&-autoPay{
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 10px;
			font-size: 16px;
			font-weight: 400;font-weight: lighter;
			color: #999999;
			line-height: 22px;
			img{
				width: 16px;
				height: 16px;
				margin-right: 3px;
				margin-top: 2px;
			}
		}
		&-info{
			position: absolute;
			bottom: 0;
			width: 400px;
			height: 64px;
			background: #F0F0F0;
			font-size: 16px;
			color: #666666;
			line-height: 22px;
			display: flex;
			justify-content: center;
			align-items: center;
			img{
				width: 18px;
				height: 18px;
				margin-right: 6px;
			}
			span{
				color: #CB2945;
				margin-left: 10px;
				display: flex;
				align-items: center;
			}
			span::after{
				content: '';
				display: block;
				width: 8px;
				height: 8px;
				border: 1px solid #CB2945;
				border-left: none;
				border-bottom: none;
				transform: rotate(45deg);
				margin-top: 2px;
			}
		}
    }
    .buyInfoMode-close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
		width: 16px;
		height: 16px;
    }
    .buyInfoMode-close img {
        width: 100%;
        height: 100%;
    }

}
</style>
